// extracted by mini-css-extract-plugin
module.exports = {"overviewKeyValuesRoot":"oh8M9MWG","keyValuesList":"BHYOj0yd"};